import { FC } from "react";
import { PageView } from "./PageView";
import { useParams } from "react-router-dom";

export const PageController: FC<{
}> = () => {
    const { destinationId } = useParams();
    return <PageView destinationId={destinationId} />
};